import { ChevronDown } from 'lucide-react';
import { useId, useState } from 'react';
import { RichText } from '@/components/shared/RichText';
import type { FaqItem } from '../types/faq.types';

/** One question. Collapsed on arrival, and it toggles on every click (US-019 AC-002/AC-003/AC-004). */
export function FaqAccordionItem({ item }: { item: FaqItem }): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const answerId = useId();

  return (
    <div className="border-line rounded-lg border">
      <h3>
        <button
          type="button"
          aria-expanded={open}
          aria-controls={answerId}
          onClick={(): void => {
            setOpen((current) => !current);
          }}
          className="text-ink flex w-full items-center justify-between gap-4 px-4 py-3 text-left text-sm font-semibold"
        >
          {item.question}
          <ChevronDown
            aria-hidden="true"
            className={`text-muted h-4 w-4 flex-none transition-transform ${open ? 'rotate-180' : ''}`}
          />
        </button>
      </h3>

      <div id={answerId} hidden={!open} className="text-muted px-4 pb-4 text-sm leading-relaxed">
        <RichText blocks={item.answer} />
      </div>
    </div>
  );
}
